import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pallet-archive',
  templateUrl: './pallet-archive.component.html',
  styleUrls: ['./pallet-archive.component.scss']
})
export class PalletArchiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
